import { createSlice } from '@reduxjs/toolkit'

import { fetchCurrentSubscription } from './actions/fetch_current_subscription'
import { reactivateSubscription } from './stages/paid_stage/reactivation_popup/slice'

const currentSubscriptionSlice = createSlice({
  name: 'currentSubscription',
  initialState: {
    addons: null,
    organization: null,
    subscription: null,
    billing_information: null,
    trial: null,
    error: null,
    initialized: false,
    before_and_after_unit_prices: null,
    is_in_pricing_test: false,
    shipping_address: null
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCurrentSubscription.pending, (state) => {
      state.initialized = false
      state.error = null
    })
    builder.addCase(fetchCurrentSubscription.fulfilled, (state, action) => {
      state.initialized = true
      state.error = null
      state.organization = action.payload.organization
      state.subscription = action.payload.subscription
      state.billing_information = action.payload.billing_information
      state.trial = action.payload.trial
      state.before_and_after_unit_prices = action.payload.before_and_after_unit_prices
      state.is_in_pricing_test = action.payload.is_in_pricing_test
      state.addons = action.payload.addons
      state.shipping_address = action.payload.shipping_address
    })
    builder.addCase(fetchCurrentSubscription.rejected, (state, action) => {
      state.initialized = true
      state.error = action.payload
    })
    // NOTE: Has a matching case in `nextBillSlice`.
    // TODO: just call `fetchSubscription` after `reactivateSubscription`, for
    //   better separation of concerns.
    builder.addCase(reactivateSubscription.fulfilled, (state, action) => {
      state.organization = action.payload.organization
      state.subscription = action.payload.subscription
      state.billing_information = action.payload.billing_information
      state.trial = action.payload.trial
    })
  }
})

export const { reducer } = currentSubscriptionSlice
